import { Car } from "./car";
import { Dealer } from "./dealer";
import { CustomerTyre } from "./customerTyre";
import { vehicleKmRecord } from "./vehicleKmRecord";

export class Customer {
  _id: string;
  mauticId: string;
  raw: Object;
  //Core
  name: string;
  email: string;
  postnummer: string;
	address: string;
	by: string;
	telefonnummer: string;
  sex: string;
  private: Boolean;
  isleasing: Boolean;
	micar_term: string;
  service_term: string;
  registration: string;
  mailChimpId: string;
  inMailChimp: Boolean;
  inMautic: Boolean;
  isSubscribed: Boolean;
  customerType: string;
  carWorkshopDnc: Boolean;
  department: string;
  hotel: string;
  iPrefer: Boolean;
  isPrefer: Boolean;
  active: Boolean;
  city: string;
  postalcode: string;

  //Car fields
  firstreg: Date;
  chassisnumber: string;
  chassisnummer: string;
  regnr: string;
  car: Car | string;
  carmake: string;
  carmodel: string;
  carversion: string;
  modelId: string;
  carid?: string;
  usedCarId?: string;
  carBrand: string;
  carKmStand: Number;
  carYear: Number;

  //Service agreement fields
  lastservice: Date;
  actualkm: Number;
  lastservice_km: Number;
  last_service_km: Number;
  last_service_km_date: Date;
  service_estimate: Date;
  serviceAgreeStart: Date;
  serviceAgreeEnd: Date;
  serviceAgreeKm: Number;
  hasServiceAgreementData: Boolean;
  lastVehicleKmRecord: vehicleKmRecord | string;

  //Tyre fields
  hasTireData: Boolean;
  tyre_term: string;
  micar_sommerdaek_maerke: string;
  micar_sommerdaek_bredde: string;
  micar_sommerdaek_profil: string;
  micar_sommerdaek_indlever: string;
  micar_sommerdaek_diameter: string;
  micar_vinterdaek_maerke: string;
  micar_vinterdaek_bredde: string;
  micar_vinterdaek_profil: string;
  micar_vinterdaek_diameter: string;
  micar_vinterdaek_indlever: string;
  micar_daek_cust_id: string;
  micar_sommerdaek_bestilt: string;
  micar_sommerdaek_tire_pri: string;
  micar_sommerdaek_min_pric: string;
  micar_vinterdaek_bestilt: string;
  micar_vinterdaek_tire_pri: string;
  micar_vintrdaek_min_price: string;
  micar_sommerdaek_1_mm: Number;
  micar_sommerdaek_2_mm: Number;
  micar_sommerdaek_3_mm: Number;
  micar_sommerdaek_4_mm: Number;
  micar_vinterdaek_1_mm1: Number;
  micar_vinterdaek_2_mm1: Number;
  micar_vinterdaek_3_mm1: Number;
  micar_vinterdaek_4_mm1: Number;
  micar_sommerdaek_status: string;
  micar_vinterdaek_status: string;
  render_winterTyreMatch: boolean;
  render_summerTyreMatch: boolean;
  summerTyre: CustomerTyre;
  winterTyre: CustomerTyre;

  //Leads fields
  lead_handled: boolean | null;
  lead_call_status: string;
  lead_costumer_feedback: string;
  lead_costumer_opinion: string;
  lead_activity_offer: boolean;
  lead_activity_mail: boolean;
  lead_activity_call: boolean;
  lead_activities: string;
  selectedItems: any;

  //References
  dealer: Array<Dealer>;
  dealer_id: Array<Dealer>;

  //Tracking fields
  imported: Date;
  haspermission: Boolean;
  micar_landingpage_calcula1: string;
  createdAt: Date;
  updatedAt: Date;
}



// WEBPACK FOOTER //
// ./src/app/_models/customer.ts